import { extend, override } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';

import ReplyList from './components/ReplyList';

export default function () {
  override(CommentPost.prototype, '$', function ($: any, selector) {
    if (selector === '.PostMention:not(.PostMention--deleted)') {
      return $(`.Post-body:first ${selector}`);
    }
    if (selector === '.Post-controls') {
      return $(`${selector}:first`);
    }
    if (selector === '.Post-mentionedBy') {
      return $(`${selector}:first`);
    }
    return $(selector);
  });

  extend(CommentPost.prototype, 'footerItems', function (items) {
    const post = this.attrs.post;

    if (!location.pathname.startsWith('/d')) {
      return;
    }

    if (items.has('replies')) {
      const replies = items.get('replies');

      items.setContent(
        'replies',
        <>
          {replies}
          <ReplyList post={post} />
        </>
      );
    }
  });
}
